export default "__VITE_ASSET__c28993ae__"